import axios from 'axios'
import store from '@/store';
import router from '../router/index';
import ismessage from '../assets/function/message';
import message from '../assets/function/message'; //消息提示框

const service = axios.create({
    baseURL: process.env.VUE_APP_API_ENDPOINT,
    timeout: 6000000
})
if(localStorage.getItem('language')){
    var lan =localStorage.getItem('language')
}

service.defaults.retry = 3; //断线重连 次数
service.defaults.retryDelay = 10000; //断线重连 间隔时间


service.interceptors.request.use(function (config) {
    store.state.api_loading = true;
    let lan_api = localStorage.getItem('language');
    config.headers['language'] = lan_api;
    config.headers['device-os'] = 'web';
    config.headers['web-name'] = 'FEB';

    // 未登陆状态
    if(router.currentRoute.path=="/cards" && sessionStorage.getItem('all_userid')){
        config.headers['userid'] = sessionStorage.getItem('all_userid');
    }else{
        if (sessionStorage.getItem('userid')) {
            config.headers['userid'] = sessionStorage.getItem('userid');
        }
    }
    
    if (sessionStorage.getItem('token')) {
        config.headers['token'] = sessionStorage.getItem('token');
    }
    return config;
}, function (error) {
    if(error){
        if(error.response&&(error.response.status!=='undefined')){
            if (error.response.status == 500 || error.response.status == 502 || error.response.status == 404) {
                setTimeout(() => {
                    store.state.api_loading = false;
                    ismessage.ismessage("error", error.response.status+" - "+error.response.statusText);
                }, 1000);
            }else{
                store.state.api_loading = false;
                if(lan=='ch'){
                    ismessage.ismessage("error", 'Network timeout');
                }else if(lan=='jp'){
                    ismessage.ismessage("error", 'ネットワークタイムアウト');
                }else{
                    ismessage.ismessage("error", 'Network timeout');
                }
            }
        }else{
            setTimeout(() => {
                store.state.api_loading = false;
                if(lan=='ch'){
                    ismessage.ismessage("error", 'Network timeout');
                }else if(lan=='jp'){
                    ismessage.ismessage("error", 'ネットワークタイムアウト');
                }else{
                    ismessage.ismessage("error", 'Network timeout');
                }
            }, 1000);
        }
    }else{
        setTimeout(() => {
            store.state.api_loading = false;
            if(lan=='ch'){
                ismessage.ismessage("error", 'Network timeout');
            }else if(lan=='jp'){
                ismessage.ismessage("error", 'ネットワークタイムアウト');
            }else{
                ismessage.ismessage("error", 'Network timeout');
            }
        }, 1000);
    }

    setTimeout(() => {
        store.state.api_loading = false;
    }, 1000)
    return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(function (response) {
    store.state.api_loading = false;
    if(
        router.currentRoute.path != "/login"&&router.currentRoute.path != "/upload" &&
        (router.currentRoute.path != "/cards"&&router.currentRoute.path != "/all_apply_card_info")
    ){
        if(response.data.code==9400){
            message.ismessage("error", response.data.msg);
            // 当前登录已失效，请重新登录
            // localStorage.clear();
            // sessionStorage.clear();
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("userid");
            sessionStorage.removeItem("fa_dlg");
            router.push("/login");
        }

        if(response.data.code == 9300){
            // localStorage.clear();
            // sessionStorage.clear();
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("userid");
            sessionStorage.removeItem("fa_dlg");
            router.push("/login");
        }

    }

    return response;
}, function (error) {
    if(error){
        if(error.response&&(error.response.status!=='undefined')){
            if (error.response.status == 500 || error.response.status == 502 || error.response.status == 404) {
                setTimeout(() => {
                    store.state.api_loading = false;
                    ismessage.ismessage("error", error.response.status+" - "+error.response.statusText);
                }, 1000);
            }else{
                store.state.api_loading = false;
                if(lan=='ch'){
                    ismessage.ismessage("error", 'Network timeout');
                }else if(lan=='jp'){
                    ismessage.ismessage("error", 'ネットワークタイムアウト');
                }else{
                    ismessage.ismessage("error", 'Network timeout');
                }
            }
        }else{
            setTimeout(() => {
                store.state.api_loading = false;
                if(lan=='ch'){
                    ismessage.ismessage("error", 'Network timeout');
                }else if(lan=='jp'){
                    ismessage.ismessage("error", 'ネットワークタイムアウト');
                }else{
                    ismessage.ismessage("error", 'Network timeout');
                }
            }, 1000);
        }
    }else{
        setTimeout(() => {
            store.state.api_loading = false;
            if(lan=='ch'){
                ismessage.ismessage("error", 'Network timeout');
            }else if(lan=='jp'){
                ismessage.ismessage("error", 'ネットワークタイムアウト');
            }else{
                ismessage.ismessage("error", 'Network timeout');
            }
        }, 1000);
    }

    setTimeout(() => {
        store.state.api_loading = false;
    }, 1000)
    return Promise.reject(error);
});

export default service